export const currencies: any = {
    "1": {
        "currency": "Afghan afghani",
        "code": "AFN",
        "symbol": "\u060b"
    },
    "2": {
        "currency": "European euro",
        "code": "EUR",
        "symbol": "\u20ac"
    },
    "4": {
        "currency": "Albanian lek",
        "code": "ALL",
        "symbol": "Lek"
    },
    "5": {
        "currency": "Algerian dinar",
        "code": "DZD",
        "symbol": "DA"
    },
    "6": {
        "currency": "United States dollar",
        "code": "USD",
        "symbol": "$"
    },
    "8": {
        "currency": "Angolan kwanza",
        "code": "AOA",
        "symbol": "Kz"
    },
    "9": {
        "currency": "East Caribbean dollar",
        "code": "XCD",
        "symbol": "$"
    },
    "11": {
        "currency": "Argentine peso",
        "code": "ARS",
        "symbol": "$"
    },
    "12": {
        "currency": "Armenian dram",
        "code": "AMD",
        "symbol": "\u058f"
    },
    "13": {
        "currency": "Aruban florin",
        "code": "AWG",
        "symbol": "\u0192"
    },
    "14": {
        "currency": "Saint Helena pound",
        "code": "SHP",
        "symbol": "\u00a3"
    },
    "17": {
        "currency": "Azerbaijan manat",
        "code": "AZN",
        "symbol": "\u20bc"
    },
    "18": {
        "currency": "Bahamian dollar",
        "code": "BSD",
        "symbol": "$"
    },
    "19": {
        "currency": "Bahraini dinar",
        "code": "BHD",
        "symbol": "BD"
    },
    "20": {
        "currency": "Bangladeshi taka",
        "code": "BDT",
        "symbol": "\u09f3"
    },
    "21": {
        "currency": "Barbadian dollar",
        "code": "BBD",
        "symbol": "$"
    },
    "24": {
        "currency": "Belize dollar",
        "code": "BZD",
        "symbol": "BZ$"
    },
    "25": {
        "currency": "West African CFA franc",
        "code": "XOF",
        "symbol": "CFA"
    },
    "26": {
        "currency": "Bermudian dollar",
        "code": "BMD",
        "symbol": "$"
    },
    "28": {
        "currency": "Bolivian boliviano",
        "code": "BOB",
        "symbol": "$b"
    },
    "30": {
        "currency": "Bosnia and Herzegovina convertible mark",
        "code": "BAM",
        "symbol": "KM"
    },
    "31": {
        "currency": "Botswana pula",
        "code": "BWP",
        "symbol": "P"
    },
    "32": {
        "currency": "Brazilian real",
        "code": "BRL",
        "symbol": "R$"
    },
    "35": {
        "currency": "Brunei dollar",
        "code": "BND",
        "symbol": "$"
    },
    "36": {
        "currency": "Bulgarian lev",
        "code": "BGN",
        "symbol": "\u043b\u0432"
    },
    "38": {
        "currency": "Burundi franc",
        "code": "BIF",
        "symbol": "FBu"
    },
    "39": {
        "currency": "Cape Verdean escudo",
        "code": "CVE",
        "symbol": "Esc"
    },
    "40": {
        "currency": "Cambodian riel",
        "code": "KHR",
        "symbol": "\u17db"
    },
    "41": {
        "currency": "Central African CFA franc",
        "code": "XAF",
        "symbol": "FCFA"
    },
    "42": {
        "currency": "Canadian dollar",
        "code": "CAD",
        "symbol": "$"
    },
    "44": {
        "currency": "Cayman Islands dollar",
        "code": "KYD",
        "symbol": "$"
    },
    "47": {
        "currency": "New Zealand dollar",
        "code": "NZD",
        "symbol": "$"
    },
    "48": {
        "currency": "Chilean peso",
        "code": "CLP",
        "symbol": "$"
    },
    "49": {
        "currency": "Chinese Yuan Renminbi",
        "code": "CNY",
        "symbol": "\u00a5"
    },
    "52": {
        "currency": "Colombian peso",
        "code": "COP",
        "symbol": "$"
    },
    "53": {
        "currency": "Comorian franc",
        "code": "KMF",
        "symbol": "CF"
    },
    "54": {
        "currency": "Congolese franc",
        "code": "CDF",
        "symbol": "CDF"
    },
    "57": {
        "currency": "Costa Rican colon",
        "code": "CRC",
        "symbol": "\u20a1"
    },
    "59": {
        "currency": "Croatian kuna",
        "code": "HRK",
        "symbol": "kn"
    },
    "60": {
        "currency": "Cuban peso",
        "code": "CUP",
        "symbol": "\u20b1"
    },
    "61": {
        "currency": "Netherlands Antillean guilder",
        "code": "ANG",
        "symbol": "\u0192"
    },
    "63": {
        "currency": "Czech koruna",
        "code": "CZK",
        "symbol": "K\u010d"
    },
    "64": {
        "currency": "Danish krone",
        "code": "DKK",
        "symbol": "kr"
    },
    "65": {
        "currency": "Djiboutian franc",
        "code": "DJF",
        "symbol": "Fdj"
    },
    "67": {
        "currency": "Dominican peso",
        "code": "DOP",
        "symbol": "RD$"
    },
    "69": {
        "currency": "Egyptian pound",
        "code": "EGP",
        "symbol": "\u00a3"
    },
    "72": {
        "currency": "Eritrean nakfa",
        "code": "ERN",
        "symbol": "Nkf"
    },
    "74": {
        "currency": "Swazi lilangeni",
        "code": "SZL",
        "symbol": "L"
    },
    "75": {
        "currency": "Ethiopian birr",
        "code": "ETB",
        "symbol": "Br"
    },
    "76": {
        "currency": "Falkland Islands pound",
        "code": "FKP",
        "symbol": "\u00a3"
    },
    "77": {
        "currency": "Faroese krona",
        "code": "FK",
        "symbol": "kr"
    },
    "78": {
        "currency": "Fijian dollar",
        "code": "FJD",
        "symbol": "$"
    },
    "82": {
        "currency": "CFP franc",
        "code": "XPF",
        "symbol": "\u20a3"
    },
    "84": {
        "currency": "Gambian dalasi",
        "code": "GMD",
        "symbol": "D"
    },
    "85": {
        "currency": "Georgian lari",
        "code": "GEL",
        "symbol": "\u20be"
    },
    "87": {
        "currency": "Ghanaian cedi",
        "code": "GHS",
        "symbol": "GH\u20b5"
    },
    "88": {
        "currency": "Gibraltar pound",
        "code": "GIP",
        "symbol": "\u00a3"
    },
    "94": {
        "currency": "Guatemalan quetzal",
        "code": "GTQ",
        "symbol": "Q"
    },
    "95": {
        "currency": "Guernsey Pound",
        "code": "GGP",
        "symbol": "\u00a3"
    },
    "96": {
        "currency": "Guinean franc",
        "code": "GNF",
        "symbol": "FG"
    },
    "98": {
        "currency": "Guyanese dollar",
        "code": "GYD",
        "symbol": "$"
    },
    "100": {
        "currency": "Honduran lempira",
        "code": "HNL",
        "symbol": "L"
    },
    "101": {
        "currency": "Hong Kong dollar",
        "code": "HKD",
        "symbol": "$"
    },
    "102": {
        "currency": "Hungarian forint",
        "code": "HUF",
        "symbol": "Ft"
    },
    "103": {
        "currency": "Icelandic krona",
        "code": "ISK",
        "symbol": "kr"
    },
    "104": {
        "currency": "Indian rupee",
        "code": "INR",
        "symbol": "\u20b9"
    },
    "105": {
        "currency": "Indonesian rupiah",
        "code": "IDR",
        "symbol": "Rp"
    },
    "107": {
        "currency": "Iranian rial",
        "code": "IRR",
        "symbol": "\ufdfc"
    },
    "108": {
        "currency": "Iraqi dinar",
        "code": "IQD",
        "symbol": "\u062f.\u0639"
    },
    "110": {
        "currency": "Manx pound",
        "code": "IMP",
        "symbol": "\u00a3"
    },
    "111": {
        "currency": "Israeli new shekel",
        "code": "ILS",
        "symbol": "\u20aa"
    },
    "113": {
        "currency": "Jamaican dollar",
        "code": "JMD",
        "symbol": "J$"
    },
    "114": {
        "currency": "Japanese yen",
        "code": "JPY",
        "symbol": "\u00a5"
    },
    "115": {
        "currency": "Jersey pound",
        "code": "JEP",
        "symbol": "\u00a3"
    },
    "116": {
        "currency": "Jordanian dinar",
        "code": "JOD",
        "symbol": "\u062f.\u0627"
    },
    "117": {
        "currency": "Kazakhstani tenge",
        "code": "KZT",
        "symbol": "\u20b8"
    },
    "118": {
        "currency": "Kenyan shilling",
        "code": "KES",
        "symbol": "Ksh"
    },
    "121": {
        "currency": "Kuwaiti dinar",
        "code": "KWD",
        "symbol": "\u062f.\u0643"
    },
    "122": {
        "currency": "Kyrgyzstani som",
        "code": "KGS",
        "symbol": "\u0441"
    },
    "123": {
        "currency": "Lao kip",
        "code": "LAK",
        "symbol": "\u20ad"
    },
    "125": {
        "currency": "Lebanese pound",
        "code": "LBP",
        "symbol": "\u0644.\u0644"
    },
    "127": {
        "currency": "Liberian dollar",
        "code": "LRD",
        "symbol": "$"
    },
    "128": {
        "currency": "Libyan dinar",
        "code": "LYD",
        "symbol": "\u0644.\u062f"
    },
    "129": {
        "currency": "Swiss franc",
        "code": "CHF",
        "symbol": "CHF"
    },
    "132": {
        "currency": "Macanese pataca",
        "code": "MOP",
        "symbol": "MOP$"
    },
    "133": {
        "currency": "Malagasy ariary",
        "code": "MGA",
        "symbol": "Ar"
    },
    "134": {
        "currency": "Malawian kwacha",
        "code": "MWK",
        "symbol": "MK"
    },
    "135": {
        "currency": "Malaysian ringgit",
        "code": "MYR",
        "symbol": "RM"
    },
    "136": {
        "currency": "Maldivian rufiyaa",
        "code": "MVR",
        "symbol": "Rf"
    },
    "142": {
        "currency": "Mauritian rupee",
        "code": "MUR",
        "symbol": "\u20a8"
    },
    "144": {
        "currency": "Mexican peso",
        "code": "MXN",
        "symbol": "$"
    },
    "146": {
        "currency": "Moldovan leu",
        "code": "MDL",
        "symbol": "L"
    },
    "148": {
        "currency": "Mongolian tugrik",
        "code": "MNT",
        "symbol": "\u20ae"
    },
    "151": {
        "currency": "Moroccan dirham",
        "code": "MAD",
        "symbol": "\u062f.\u0645."
    },
    "152": {
        "currency": "Mozambican metical",
        "code": "MZN",
        "symbol": "MT"
    },
    "153": {
        "currency": "Myanmar kyat",
        "code": "MMK",
        "symbol": "K"
    },
    "154": {
        "currency": "Namibian dollar",
        "code": "NAD",
        "symbol": "$"
    },
    "156": {
        "currency": "Nepalese rupee",
        "code": "NPR",
        "symbol": "\u0930\u0942"
    },
    "160": {
        "currency": "Nicaraguan cordoba",
        "code": "NIO",
        "symbol": "C$"
    },
    "162": {
        "currency": "Nigerian naira",
        "code": "NGN",
        "symbol": "\u20a6"
    },
    "166": {
        "currency": "North Korean won",
        "code": "KPW",
        "symbol": "\u20a9"
    },
    "167": {
        "currency": "Macedonian denar",
        "code": "MKD",
        "symbol": "\u0434\u0435\u043d"
    },
    "168": {
        "currency": "Norwegian krone",
        "code": "NOK",
        "symbol": "kr"
    },
    "169": {
        "currency": "Omani rial",
        "code": "OMR",
        "symbol": "\u0631.\u0639."
    },
    "170": {
        "currency": "Pakistani rupee",
        "code": "PKR",
        "symbol": "\u20a8"
    },
    "174": {
        "currency": "Papua New Guinean kina",
        "code": "PGK",
        "symbol": "K"
    },
    "175": {
        "currency": "Paraguayan guarani",
        "code": "PYG",
        "symbol": "\u20b2"
    },
    "176": {
        "currency": "Peruvian sol",
        "code": "PEN",
        "symbol": "S/."
    },
    "177": {
        "currency": "Philippine peso",
        "code": "PHP",
        "symbol": "\u20b1"
    },
    "179": {
        "currency": "Polish zloty",
        "code": "PLN",
        "symbol": "z\u0142"
    },
    "182": {
        "currency": "Qatari riyal",
        "code": "QAR",
        "symbol": "\u0631.\u0642"
    },
    "184": {
        "currency": "Romanian leu",
        "code": "RON",
        "symbol": "lei"
    },
    "185": {
        "currency": "Russian ruble",
        "code": "RUB",
        "symbol": "\u20bd"
    },
    "186": {
        "currency": "Rwandan franc",
        "code": "RWF",
        "symbol": "RF"
    },
    "195": {
        "currency": "Samoan tala",
        "code": "WST",
        "symbol": "WS$"
    },
    "198": {
        "currency": "Saudi Arabian riyal",
        "code": "SAR",
        "symbol": "\u0631.\u0633"
    },
    "200": {
        "currency": "Serbian dinar",
        "code": "RSD",
        "symbol": "\u0434\u0438\u043d."
    },
    "201": {
        "currency": "Seychellois rupee",
        "code": "SCR",
        "symbol": "\u20a8"
    },
    "202": {
        "currency": "Sierra Leonean leone",
        "code": "SLL",
        "symbol": "Le"
    },
    "203": {
        "currency": "Singapore dollar",
        "code": "SGD",
        "symbol": "$"
    },
    "208": {
        "currency": "Solomon Islands dollar",
        "code": "SBD",
        "symbol": "$"
    },
    "209": {
        "currency": "Somali shilling",
        "code": "SOS",
        "symbol": "Sh"
    },
    "210": {
        "currency": "South African rand",
        "code": "ZAR",
        "symbol": "R"
    },
    "211": {
        "currency": "Pound sterling",
        "code": "GBP",
        "symbol": "\u00a3"
    },
    "212": {
        "currency": "South Korean won",
        "code": "KRW",
        "symbol": "\u20a9"
    },
    "213": {
        "currency": "South Sudanese pound",
        "code": "SSP",
        "symbol": "\u00a3"
    },
    "215": {
        "currency": "Sri Lankan rupee",
        "code": "LKR",
        "symbol": "\u20a8"
    },
    "216": {
        "currency": "Sudanese pound",
        "code": "SDG",
        "symbol": "\u062c.\u0633."
    },
    "217": {
        "currency": "Surinamese dollar",
        "code": "SRD",
        "symbol": "$"
    },
    "219": {
        "currency": "Swedish krona",
        "code": "SEK",
        "symbol": "kr"
    },
    "221": {
        "currency": "Syrian pound",
        "code": "SYP",
        "symbol": "\u00a3S"
    },
    "222": {
        "currency": "New Taiwan dollar",
        "code": "TWD",
        "symbol": "NT$"
    },
    "223": {
        "currency": "Tajikistani somoni",
        "code": "TJS",
        "symbol": "\u0405\u041c"
    },
    "224": {
        "currency": "Tanzanian shilling",
        "code": "TZS",
        "symbol": "TSh"
    },
    "225": {
        "currency": "Thai baht",
        "code": "THB",
        "symbol": "\u0e3f"
    },
    "229": {
        "currency": "Tongan pa\u2019anga",
        "code": "TOP",
        "symbol": "T$"
    },
    "230": {
        "currency": "Trinidad and Tobago dollar",
        "code": "TTD",
        "symbol": "TT$"
    },
    "232": {
        "currency": "Tunisian dinar",
        "code": "TND",
        "symbol": "\u062f.\u062a"
    },
    "233": {
        "currency": "Turkish lira",
        "code": "TRY",
        "symbol": "\u20ba"
    },
    "234": {
        "currency": "Turkmen manat",
        "code": "TMT",
        "symbol": "m"
    },
    "237": {
        "currency": "Ugandan shilling",
        "code": "UGX",
        "symbol": "USh"
    },
    "238": {
        "currency": "Ukrainian hryvnia",
        "code": "UAH",
        "symbol": "\u20b4"
    },
    "239": {
        "currency": "UAE dirham",
        "code": "AED",
        "symbol": "\u062f.\u0625"
    },
    "242": {
        "currency": "Uruguayan peso",
        "code": "UYU",
        "symbol": "$U"
    },
    "244": {
        "currency": "Uzbekistani som",
        "code": "UZS",
        "symbol": "UZS"
    },
    "248": {
        "currency": "Vietnamese dong",
        "code": "VND",
        "symbol": "\u20ab"
    },
    "251": {
        "currency": "Yemeni rial",
        "code": "YER",
        "symbol": "\ufdfc"
    },
    "252": {
        "currency": "Zambian kwacha",
        "code": "ZMW",
        "symbol": "ZK"
    }
}